import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { TextInput, Dropdown, Button, Image } from "hesus-ui-kit";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import { filterUnit } from "@utils/utils";
import {
  GridRow,
  MarginWrapper,
  GridItem,
  ErrorDiv,
  RequiredMessage,
} from "../../AddEditSupplier.styled";
import "../../AddEditSupplier.scss";
import errorIcon from "@icons/ic-error.svg";

const MarginSection = (props) => {
  const { t, item, itemIndex, isEdit, onChange } = props;
  return (
    <>
      <GridRow column="45% 50%">
        <TextInput
          id="add-supplier-planning-margin-planned-qty"
          type="text"
          label={t("SUPPLIERS_PLANNING_FORM_QUANTITY")}
          isFloat
          value={String(item.marginQuantity.value)}
          onChange={(e) => {
            onChange(e, itemIndex, "marginQuantity");
          }}
          containerStyles={{ marginTop: "21px" }}
          errorStyles={{ "font-style": "italic", "font-weight": "400" }}
          labelStyles={
            item.marginQuantity.error !== "" ? labelStylesError : labelStyles
          }
          inputStyles={
            item.marginQuantity.error !== "" ? inputStylesError : inputStyles
          }
          required
          error={item.marginQuantity.error}
          placeholder={t("SUPPLIERS_PLANNING_FORM_QUANTITY")}
        />
        <div>
          <Dropdown
            id="add-supplier-planning-margin-planned-unit"
            label={t("SUPPLIERS_PLANNING_FORM_UNIT")}
            name="unit"
            value={item.marginUnit.value}
            onChange={(e) => {
              onChange(e, itemIndex, "marginUnit");
            }}
            defaultOption={t("UNIT")}
            options={filterUnit(item.itemInfo.unit, t)}
            labelStyles={
              item.marginUnit.error !== "" ? labelStylesError : labelStyles
            }
            inputStyles={
              item.marginUnit.error !== "" ? inputStylesError : inputStyles
            }
            required
            error={item.marginUnit.error}
          />
        </div>
      </GridRow>
      <GridRow>
        <MarginWrapper>
          {item.marginRate.value === "" && (
            <Button
              styles={{
                width: "100%",
                padding: "10px 20px",
                color: "#0a4986",
                background: "#e7edf3",
                border: "1px solid #0a4986",
                fontWeight: "700",
                "&:hover": {
                  backgroundColor: "#e7edf3",
                },
              }}
            >
              {t("SUPPLIERS_PLANNING_FORM_MARGIN") + " : " + "--.--%"}
            </Button>
          )}
          {item.marginRate.value !== "" &&
            item.marginRate.value >= item.expectedMargin.value && (
              <Button
                styles={{
                  width: "100%",
                  padding: "10px 20px",
                  color: "#32a728",
                  background: "#ebf6ea",
                  border: "1px solid #32a728",
                  fontWeight: "700",
                  "&:hover": {
                    backgroundColor: "#ebf6ea",
                  },
                }}
              >
                {t("SUPPLIERS_PLANNING_FORM_MARGIN") +
                  " : " +
                  item.marginRate.value +
                  "%"}
              </Button>
            )}
          {item.marginRate.value !== "" &&
            item.marginRate.value < item.expectedMargin.value &&
            item.marginRate.value >= 0 && (
              <Button
                styles={{
                  width: "100%",
                  padding: "10px 20px",
                  color: "#F08046",
                  background: "#fef2ed",
                  border: "1px solid #F08046",
                  fontWeight: "700",
                  "&:hover": {
                    backgroundColor: "#fef2ed",
                  },
                }}
              >
                {t("SUPPLIERS_PLANNING_FORM_MARGIN") +
                  " : " +
                  item.marginRate.value +
                  "%"}
              </Button>
            )}
          {item.marginRate.value !== "" && item.marginRate.value < 0 && (
            <Button
              styles={{
                width: "100%",
                padding: "10px 20px",
                color: "#E83F1E",
                background: "#fdf0ee",
                border: "1px solid #E83F1E",
                fontWeight: "700",
                "&:hover": {
                  backgroundColor: "#fdf0ee",
                },
              }}
            >
              {t("SUPPLIERS_PLANNING_FORM_MARGIN") +
                " : " +
                item.marginRate.value +
                "%"}
            </Button>
          )}
        </MarginWrapper>
      </GridRow>
      <GridRow>
        <GridItem
          fontWeight="400"
          fontSize="14px"
          color="#474747"
          fontStyle="italic"
          padding="0px"
        >
          {t("SUPPLIERS_PLANNING_FORM_EXPECTED_MARGIN") +
            " : " +
            item.expectedMargin.value +
            "%"}
        </GridItem>
      </GridRow>
      {item.marginRate.error !== "" && (
        <GridRow column="1fr">
          <ErrorDiv>
            <RequiredMessage>
              <Image
                src={errorIcon}
                alt="warning"
                className="add-edit-supplier-list__error-icon"
              />{" "}
              {t(item.marginRate.error)}
            </RequiredMessage>
          </ErrorDiv>
        </GridRow>
      )}
    </>
  );
};

MarginSection.propTypes = {
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  search: PropTypes.string,
  onlyTranport: PropTypes.bool,
};

MarginSection.defaultProps = {
  isEdit: false,
  search: "",
  onlyTranport: false,
};
export default withTranslation()(MarginSection);
